module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage"
  }, [_c('a', {
    attrs: {
      "id": "title61"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("As for the poem, one dragon, however hot, does not make a summer, or a host; and a man might well exchange for one good dragon what he would not sell for a wilderness. And dragons, real dragons, essential both to the machinery and the ideas of a poem or tale, are actually rare.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—J. R. R. TOLKIEN,"), _c('br'), _vm._v(" “Beowulf: The Monsters and the Critics”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("He is at once a stratum of the earth and a streamer in the air, no painted dragon but a figure of real oneiric power, one that can easily survive the prejudices which arise at the very mention of the word “dragon.”")])])])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—SEAMUS HEANEY,"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Introduction to his translation of")]), _vm._v(" Beowulf")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e659b66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429949880_epi01.vue
// module id = 72
// module chunks = 0